import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, Subject, of } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DynamicFormDesignerConfig } from '../utils/dynamic-form-designer-config';
import { skipErrorHandler } from '../utils/http-helper';
import { OptionProperty } from '../types';
import { OptionItem } from '../types/control.types';
import { resolveUrl } from '../utils/utils';

@Injectable({
  providedIn: 'root'
})
export class OptionService {
  private _config: DynamicFormDesignerConfig;

  constructor(private httpClient: HttpClient, config: DynamicFormDesignerConfig) {
    this._config = config;
    this.httpClient = skipErrorHandler(this.httpClient);
  }

  get(url: string): Observable<any> {
    url = resolveUrl(url, this._config.optionDataSource.baseUrl);
    return this.httpClient.get(url).pipe();
  }

  /**
   * è·åéé¡¹å¼
   *
   */
  getSelectOptions(
    properties: Array<OptionProperty>,
    globalData: any,
    defaultValue: string = ''
  ): Observable<Array<OptionItem>> {
    const option: OptionProperty = properties.find((s) => s.selected === true);
    const value = this.getVarValueByUrl(option.value, globalData);
    return this.getSelectOptionsByProperty(option, value, true);
  }

  /**
   * æ ¹æ®é»è®¤åéå¼è·åéé¡¹å¼
   *
   * @param  properties
   * @param  [defaultVarValue=''] é»è®¤åéå¼
   * @memberof OptionService
   */
  getSelectOptionsByDefaultVarValue(
    properties: Array<OptionProperty>,
    defaultVarValue: string = ''
  ): Observable<Array<OptionItem>> {
    const option: OptionProperty = properties.find((s) => s.selected === true);
    return this.getSelectOptionsByProperty(option, defaultVarValue, true);
  }

  /**
   * è·åéé¡¹å¼ æ ¹æ®åºå®éé¡¹
   *
   * @memberof OptionService
   */
  getSelectOptionsByProperty(
    property: OptionProperty,
    newValue: string = '',
    isFirst: boolean
  ): Observable<Array<OptionItem>> {
    const sub: Subject<Array<OptionItem>> = new Subject<Array<OptionItem>>();
    const option: OptionProperty = property;
    if (!option) {
      return of([]);
    }
    // æ°æ®æºæ°æ®
    if (option.id === 'dataSource') {
      const valueMember = option.valueMember ? option.valueMember : 'id';
      const displayMember = option.displayMember ? option.displayMember : 'text';
      if (!option.value) {
        return of([]);
      }
      // http è¯·æ±
      this.get(this.getUrl(option.value, newValue))
        .pipe(
          finalize(() => {
            sub.complete();
          })
        )
        .subscribe(
          (r: Array<any>) => {
            // ä¸ä¿çå­å¨å­æ®µä¸ºç©ºçå¼
            const res: Array<OptionItem> = [];
            r.forEach((s) => {
              if (s[valueMember]) {
                res.push({ id: s[valueMember], text: s[displayMember], data: s });
              }
            });
            sub.next(res);
          },
          (error) => {
            sub.next([]);
            sub.error(error);
          }
        );
      return sub;
    }
    // èªå®ä¹æ°æ®
    setTimeout(() => {
      if (!isFirst) {
        // ä¸æ´æ°æ°æ®
        sub.complete();
      } else {
        const resOp = option.value.split(/[\n]/).map((s: any) => {
          return { id: s, text: s };
        });
        sub.next(resOp);
        sub.complete();
      }
    }, 0);

    return sub;
  }
  /**
   * è·åè®¡ç®åçurl
   *
   * @param  url
   * @param  newVal
   * @memberof OptionService
   */
  getUrl(url: string, newVal: string): string {
    const varName = this.getVarName(url);
    if (!varName) {
      return url;
    }
    return url.replace(`\${${varName}\}`, newVal);
  }
  /**
   * æ ¹æ®urlè·ååéå¼
   *
   * @memberof OptionService
   */
  getVarValueByUrl(url: string, globalData: any): string {
    const varName = this.getVarName(url);
    if (!varName) {
      return '';
    }
    return this.getVarValue(varName, globalData);
  }
  /**
   * è·ååéåç§°
   *
   * @memberof OptionService
   */
  getVarName(url: string): string {
    if (!url) {
      return '';
    }

    // firefox ä¸æ¯æåè¡æ­è¨ï¼æä»¥è¦æªä¸ä¸å­ç¬¦ä¸²
    const matches = url.match(/(\$\{)[\\_\.A-Za-z0-9]+(\})+/g);

    if (matches && matches.length > 0) {
      const varName = matches[0];
      return varName.substring(2, varName.length - 1);
    }
    return '';
  }
  /**
   * æ ¹æ®åéåè·ååéå¼
   *
   * @memberof OptionService
   */
  getVarValue(varName: string, globalData: any): string {
    if (!varName || !globalData) {
      return '';
    }
    const varNames = varName.split('.');
    let tempData: any = globalData;
    for (let i = 0; i < varNames.length; i++) {
      if (!tempData) {
        return '';
      }
      tempData = tempData[varNames[i]];
    }

    return tempData;
  }
}
